import React from 'react';

const Podcasts = () => {
  return (
    <div id="podcast">
      <h1>This is the Podcasts section</h1>
      
    </div>
  );
}

export default Podcasts;
